// Module
var code = `<div on-mousedown="@this.onMouseDown(event)" on-click="showPopup" id="multiComboBox"
     class="js-combobox{{#if .isPopupShown}} checked{{/if}} {{.additionalClass}}"
     style="{{>visibility}}"
     {{#.focused}}focused="" {{/}}
     {{#if !(.enabled) || !(.items.length)}}disabled="" {{/if}}>
    <div>{{.selectionText}}</div>

    <div class="js-combobox-arrow-down">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#ArrowDown"></use>
        </svg>
    </div>
</div>`;
// Exports
export default code;